import { InputComponent } from "../../_components/InputComponent";
import { SelectComponent } from "../../_components/SelectComponent";

import { isPotentialVulgarFieldValid } from "../../_api/mal-validations";
import { IStoreSelector, useApplicationState } from "../../_store/useApplicationState";
import { LoanDetails, RefinanceLoan } from "../../_store/loan";

import { IApplicationStep } from "../../_store/application";
import { LIEN_HOLDER_COMPANIES } from "./LIEN_HOLDER_COMPANIES";

export const LienHolder = (
  props: IStoreSelector<RefinanceLoan> & IApplicationStep
) => {
  const loan_details = useApplicationState((s) => s.loan_details);
  const lien_holder = loan_details((loan) => loan.lien_holder);
  const { getState: getter, setState: setter} = loan_details;

  const onLienHolderChange = (value: string | undefined) => {
    if (value !== "Other") {
      setter({ lien_holder_other: "" });
    }
  };

  const validateLienHolderOtherAsync = async (): Promise<
    [boolean, (label: string) => string]
  > => {
    const { lien_holder_other } = getter();

    const [isVulgarFree, vulgarErrorMessage] =
      await isPotentialVulgarFieldValid(lien_holder_other!);
    if (!isVulgarFree) {
      return [false, vulgarErrorMessage];
    }

    return [true, () => ""];
  };

  const options = LIEN_HOLDER_COMPANIES.map((x) => (
    <option key={x}>{x}</option>
  ));

  return (
    <>
      <SelectComponent<Pick<RefinanceLoan, "lien_holder">, string>
        label="Lien Holder"
        infoIcon="Lien Holder"
        onChange={onLienHolderChange}
        className="col"
        store={props.store}
        selector={(loan) => loan.lien_holder}
        step={props.step}
      >
        <option></option>
        {options}
        <option>Other</option>
      </SelectComponent>

      {lien_holder === "Other" && (
        <InputComponent<Pick<LoanDetails, "lien_holder_other">, string>
          label="Lien Holder Name"
          maxLength={50}
          // validate={(value, force, isDirty) => validateLienHolderOther(value, force, isDirty)}
          validateAsync={validateLienHolderOtherAsync}
          testId="remainingBalance"
          className="col"
          store={props.store}
          selector={(loan) => loan.lien_holder_other}
          step={props.step}
        />
      )}
    </>
  );
};
